<template>
    <div class="security">
        <div class="title-contents">
            <div class="icon-holder">
                <img src="@/assets/icons/security.svg" alt="">
            </div>
            <h2>Защита аккаунта</h2>
        </div>
        <div class="link-account">
            <large_button color="blue" class="media-icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#vk_filter0_d)">
                        <path d="M26.8039 20.9198C26.7448 20.8208 26.379 20.026 24.6189 18.3924C22.7762 16.6818 23.0238 16.9595 25.2432 14.0017C26.5949 12.2003 27.1353 11.1002 26.9662 10.6299C26.8053 10.1817 25.8111 10.2999 25.8111 10.2999L22.5053 10.3192C22.5053 10.3192 22.2606 10.2862 22.0777 10.3948C21.9003 10.5021 21.7862 10.7496 21.7862 10.7496C21.7862 10.7496 21.2622 12.1439 20.5637 13.3293C19.091 15.8306 18.501 15.9626 18.2604 15.8072C17.7007 15.4455 17.841 14.3523 17.841 13.5768C17.841 11.1525 18.2081 10.1418 17.1246 9.88051C16.7643 9.79388 16.5003 9.73613 15.5803 9.7265C14.4005 9.71412 13.4008 9.73062 12.8356 10.007C12.4589 10.1913 12.1687 10.6024 12.3461 10.6258C12.5647 10.6547 13.0598 10.7592 13.3224 11.1167C13.6621 11.5774 13.6497 12.6142 13.6497 12.6142C13.6497 12.6142 13.845 15.4676 13.1945 15.8223C12.7476 16.0657 12.1357 15.5693 10.8225 13.299C10.1501 12.1371 9.64127 10.8513 9.64127 10.8513C9.64127 10.8513 9.54364 10.6121 9.369 10.4842C9.15724 10.3288 8.86021 10.2793 8.86021 10.2793L5.71673 10.2985C5.71673 10.2985 5.24507 10.3123 5.07181 10.5172C4.9178 10.7001 5.05944 11.0768 5.05944 11.0768C5.05944 11.0768 7.52087 16.8344 10.3068 19.7372C12.8631 22.3981 15.7646 22.2234 15.7646 22.2234H17.0792C17.0792 22.2234 17.4766 22.1794 17.6787 21.9608C17.8657 21.76 17.8589 21.3832 17.8589 21.3832C17.8589 21.3832 17.8327 19.619 18.6523 19.3591C19.4595 19.1033 20.4963 21.0642 21.595 21.8191C22.4256 22.3898 23.0568 22.2647 23.0568 22.2647L25.9953 22.2234C25.9953 22.2234 27.5327 22.1285 26.8039 20.9198Z" fill="url(#vk_paint0_linear)"/>
                    </g>
                    <defs>
                        <filter id="vk_filter0_d" x="0" y="2" width="32" height="32" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                            <feOffset dy="2"/>
                            <feGaussianBlur stdDeviation="2"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0.0980392 0 0 0 0 0.513726 0 0 0 0 0.898039 0 0 0 1 0"/>
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                        </filter>
                        <linearGradient id="vk_paint0_linear" x1="16" y1="9.72363" x2="16" y2="22.2763" gradientUnits="userSpaceOnUse">
                            <stop offset="0.480263" stop-color="white"/>
                            <stop offset="1" stop-color="white" stop-opacity="0.48"/>
                        </linearGradient>
                    </defs>
                </svg>
            </large_button>
            <div class="content-block">
                <div class="about">
                    <h3>Привязать ВКонтакте</h3>
                    <a :href="vkLink" target="_blank" class="your-media" v-if="vk">
                        {{vkInfo.first_name}}
                        {{vkInfo.last_name}}
                    </a>
                    <p v-show="!vk">Привяжите аккаунт, чтобы восстановить пароль, если вдруг забудете.</p>
                </div>
                <div class="linking" v-if="!vk">
                    <secondary_button color="blue" @click.native="linkVk">Привязать аккаунт</secondary_button>
                </div>
<!--                <div class="linking remove" v-else>
                    <secondary_button color="gray" @click.native="removeVk">Отвязать аккаунт</secondary_button>
                </div>-->
            </div>
        </div>
        <div class="line"></div>
        <div class="link-account">
            <large_button color="green" class="media-icon">
                <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#mail_filter0_d)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5 23.8046L5.90603 11.039L17.1232 5.91663L27 12.9519L26.1497 26.0833L5 23.8046ZM16.0011 19.4194L7.26508 12.9882L6.6759 22.6109L24.8868 24.5314L25.4722 14.968L16.0011 19.4194Z" fill="url(#mail_paint0_linear)"/>
                    </g>
                    <defs>
                        <filter id="mail_filter0_d" x="0" y="2" width="32" height="32" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                            <feOffset dy="2"/>
                            <feGaussianBlur stdDeviation="2"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0.0470588 0 0 0 0 0.627451 0 0 0 0 0.423529 0 0 0 1 0"/>
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                        </filter>
                        <linearGradient id="mail_paint0_linear" x1="16" y1="5.91663" x2="16" y2="26.0833" gradientUnits="userSpaceOnUse">
                            <stop offset="0.480263" stop-color="white"/>
                            <stop offset="1" stop-color="white" stop-opacity="0.48"/>
                        </linearGradient>
                    </defs>
                </svg>
            </large_button>
            <div class="content-block">
                <div class="about">
                    <h3>Привязать Почту</h3>
                    <p class="your-media" v-if="email">{{email}}</p>
                    <p v-else>Привяжите аккаунт, чтобы восстановить пароль, если вдруг забудете.</p>
                </div>
                <div v-if="!email">
                    <div class="linking">
                        <text_field placeholder="Почта" v-model="newEmail"/>
                    </div>
                    <div class="linking">
                        <secondary_button color="green" @click.native="linkEmail" :disabled="inProgress">Привязать почту</secondary_button>
                    </div>
                    <p class="error-block" v-if="error.setEmailResult">{{error.setEmailResult}}</p>
                </div>
                <div class="linking remove" v-else>
                    <secondary_button color="gray" @click.native="removeEmail" :disabled="inProgress">Отвязать почту</secondary_button>
                    <p class="error-block" v-if="error.remEmailResult">{{error.remEmailResult}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import large_button from '@/elements/large_button.vue'
    import secondary_button from '@/elements/secondary_button.vue'
    import text_field from '@/elements/text_field.vue'
    import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

    export default {
        name: "security",
        components:{
            large_button,
            secondary_button,
            text_field,
        },
        data: ()=>({
            newEmail: ''
        }),
        computed: {
            vk(){
                return this.$auth.user().user && this.$auth.user().user.vk;
            },
            vkInfo(){
                return this.getVkInfo(this.vk);
            },
            email(){
                return this.$auth.user().user && this.$auth.user().user.email;
            },
            inProgress(){
                return Object.values(this.pending).some(v=>v);
            },
            vkLink(){
                return `//vk.com/id${this.vk}`;
            },
            ...mapGetters('cabinet', ['getVkInfo']),
            ...mapState('cabinet', ['pending', 'error'])
        },
        methods: {
            linkEmail(){
                if(this.inProgress) return;
                this.setEmail({params: {
                        email: this.newEmail
                 }}).then(({data})=>{
                    this.putNotificationDefault(data || 'Почта успешно привязана');
                    this.setParamUser('email', this.newEmail);
                }).catch((err)=>{
                    this.putNotificationErr('Ошибка привязки почты: '+err);
                });
            },
            removeEmail(){
                if(this.inProgress) return;
                this.remEmail()
                    .then(({data})=>{
                        this.putNotificationDefault(data || 'Почта успешно отвязана');
                        this.setParamUser('email', false);
                    }).catch((err)=>{
                        this.putNotificationErr('Ошибка отвязки почты: '+err);
                    });
            },
            linkVk(){
                if(this.inProgress) return;
                let data = new FormData();
                this.authVk().then((session)=>{
                    for (const key in session) {
                        if(key !== 'user') data.append(`vk[${key}]`, session[key]);
                    }
                    return this.setVk({data});
                }).then(({data})=>{
                    this.putNotificationDefault(data || 'VK привязан');
                    this.setParamUser('vk', '...');
                    return this.$auth.fetch();
                }).catch((err)=>{
                    this.putNotificationErr('Ошибка привязки VK: '+err);
                });
            },
            removeVk(){
                if(this.inProgress) return;
                this.remVk().then(({data})=>{
                    this.putNotificationDefault(data || 'VK успешно отвязан');
                    this.setParamUser('vk', false);
                }).catch((err)=>{
                    this.putNotificationErr('Ошибка отвязки VK: '+err);
                });
            },
            setParamUser(param, val){
                let user = this.$auth.user();
                user.user[param] = val;
                this.$auth.user(user);
            },
            ...mapActions('cabinet', ['authVk','setEmail','remEmail','setVk','remVk']),
            ...mapMutations('notifications', ['putNotificationDefault','putNotificationErr'])
        }
    }
</script>

<style scoped lang="scss">
    .security{
        display: flex;
        flex-direction: column;
        .link-account{
            width: 70%;
            display: grid;
            grid-template-columns: auto 1fr;
            grid-gap: 28px;

            .media-icon{
                cursor: default !important;
                width: 48px;
                height: 48px;
            }
            .about{
                h3{
                    margin-bottom: 8px;
                }
                p, a{
                    margin-bottom: 20px;
                }
                a{
                    display: block;
                    text-decoration: underline;
                }
                .your-media{
                    color: $blue;
                }
            }
            .linking{
                width: 214px;
            }
        }
        .line{
            margin: 32px 0;
        }
        @include laptop{
            .content-block{
                max-width: 300px;
            }
        }
        @include mobile{
            .content-block{
                max-width: 200px;
            }
            .link-account{
                grid-gap: 23px;
            }
            .line{
                margin: 20px 0;
            }
            p{
                margin-bottom: 16px;
            }
        }
    }
</style>